import queryString from 'query-string';
import get from 'lodash/get';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import * as Error404Actions from 'rebook/apps/base/actions/Error404Actions';
import {
  SEARCH_SEARCH_RIGHTHOLDERS_SET_DATA,
  SEARCH_SEARCH_RIGHTHOLDERS_RESET_DATA,
} from 'rebook/apps/search/constants';


export const fetchInitialData = (location = {}) => {
  return async(dispatch, getState) => {
    const { ssr, searchRightholders: currentState } = getState();
    const limit = 12;
    const pageNumber = parseInt(get(ssr, 'query.page', 1));

    let newState = {
      pageNumber,
    };
    if (location && location.state) {
      newState = {
        ...newState,
        ...location.state,
        isLoading: false,
        lastPageNumber: Math.ceil(location.state.rightholderCount / limit),
      };
    }

    dispatch(setData(newState));
    if (!newState.rightholderList || currentState.pageNumber !== pageNumber) {
      await dispatch(fetchRightholders(pageNumber));
    }
  };
};

export const fetchRightholders = (pageNumber = 1) => {
  return async(dispatch, getState) => {
    const { ssr, searchRightholders: currentState } = getState();
    const limit = 10;

    let query;

    if (ssr.query && ssr.query.q) {
      query = ssr.query.q;
    }
    else {
      query = currentState.query;
    }

    if (!query) {
      dispatch(setData({ isLoading: false }));
      return;
    }

    dispatch(setData({ isLoading: true }));

    let queryParams = {
      q: query,
      limit,
      offset: (pageNumber - 1) * limit,
    };

    const qs = queryString.stringify(queryParams);
    const url = `/api/search/rightholders/?${qs}`;

    return await fetchQuery(url, { apiVersion: 5, headers: ssr.headers })
      .then(({ data }) => {
        const lastPageNumber = Math.ceil(data.meta.total_count / limit);
        dispatch(setData({
          rightholderList: data.objects,
          rightholderCount: data.meta.total_count,
          query,
          pageNumber,
          lastPageNumber,
          isLoading: false,
        }));
      })
      .catch(({ data, resp, error }) => {
        if (resp.status === 404) {
          dispatch(Error404Actions.show());
        }
        else {
          Raven.captureMessage('failed to load rightholder list due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
              error,
            },
          });
          throw new Error('failed to load rightholder list detail due to server error');
        }
      });
  };
};

const setSeoMeta = () => {
  return (dispatch, getState) => {
    const { ssr, searchRightholders: currentState } = getState();
    let rightholderName;

    if (ssr.query && ssr.query.q) {
      rightholderName = ssr.query.q;
    }
    else {
      rightholderName = currentState.query;
    }

    const title = `Все издатели по запросу «${rightholderName}»`;

    dispatch(SeoActions.setData({
      title,
    }));
  };
};

export const setData = (payload) => {
  return (dispatch) => {
    const { rightholderList } = payload;
    dispatch({
      type: SEARCH_SEARCH_RIGHTHOLDERS_SET_DATA,
      payload,
    });
    if (rightholderList) {
      dispatch(setSeoMeta());
    }
  };
};

export const resetData = () => {
  return (dispatch) => {
    dispatch(SeoActions.resetData());
    dispatch({
      type: SEARCH_SEARCH_RIGHTHOLDERS_RESET_DATA,
    });
  };
};
